import React from 'react'

import {
  RichTextComponent,
  // @ts-expect-error — importing js
} from '..'

import { WebinarPanelComponent } from '../../features/WebinarSidebarFeature/components'
import WebinarInfoSidebarSpeakerList from './WebinarInfoSidebarSpeakerList'

import './WebinarInfoSidebarComponent.scss'

interface WebinarInfoSidebarProps {
  liveData: Record<string, any> // TODO: properly type this
}

const WebinarInfoSidebarComponent = ({ liveData }: WebinarInfoSidebarProps) => {
  if (!liveData) return null

  const {
    name,
    primary_timezone_live_date__date,
    primary_timezone_live_date__time,
    description_html,
  } = liveData

  return (
    <div className="webinar-info-sidebar-component">
      <WebinarPanelComponent>
        <div className="webinar-info-header">
          <div className="webinar-info-title">{name}</div>
          <div className="webinar-date">
            {`${primary_timezone_live_date__date} • ${primary_timezone_live_date__time}`}
          </div>
        </div>

        {description_html && <RichTextComponent text={description_html} />}

        <WebinarInfoSidebarSpeakerList />
      </WebinarPanelComponent>
    </div>
  )
}

export default WebinarInfoSidebarComponent
